import React from "react";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../../ThemeContext";
import { ReactComponent as ArrowLeftIcon } from "../../assets/icons/arrowLeft.svg";
import { ReactComponent as ID } from "../../assets/icons/ID.svg";
import { ReactComponent as Wallet } from "../../assets/icons/Wallet.svg";
import { ReactComponent as ProfCalendar } from "../../assets/icons/ProfCalendar.svg";
import { ReactComponent as Logout } from "../../assets/icons/logout.svg";
import styles from "./ProfileMenuList.module.css";
import ThemeToggleButton from "../../ThemeToggleButton";

interface MenuItem {
  id: number;
  title: string;
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  path: string;
}
  
const menuItems: MenuItem[] = [
  { id: 1, title: "اطلاعات شخصی", icon: ID, path: "/profile/info" },
  { id: 2, title: "تاریخچه تراکنش‌ها", icon: Wallet, path: "/profile/transactions" },
  { id: 3, title: "تاریخچه وقت‌های رزرو شده", icon: ProfCalendar, path: "/profile/BookingHistory" },
];

const ProfileMenuList: React.FC = () => {
  const navigate = useNavigate();
  const { resetTheme } = useTheme();

  const handleNavigation = (path: string) => {
    navigate(path);
  };

  const logout = () => {
    localStorage.clear();
    resetTheme();
    navigate("/");
  };

  return (
    <>
      <div className={styles.menuListContainer}>
        {/* آیتم‌های منو */}
        {menuItems.map((item) => (
          <div
            key={item.id}
            className={styles.menuItem}
            onClick={() => handleNavigation(item.path)}
            style={{ cursor: "pointer" }}
          >
            <div className={styles.chevronContainer}>
              <ArrowLeftIcon className={styles.chevronIcon} />
            </div>
            <p className={styles.menuText}>{item.title}</p>
            <div className={styles.iconContainer}>
              <item.icon className={styles.menuIcon} />
            </div>
          </div>
        ))}

        {/* دکمه تغییر تم */}
        <ThemeToggleButton />

        {/* دکمه خروج از حساب */}
        <div
          className={styles.menuItem}
          onClick={() => logout()}
          style={{ cursor: "pointer", background: "#F4C9DE80" }}
        >
          <div className={styles.chevronContainer}>
            <ArrowLeftIcon className={styles.chevronIcon} />
          </div>
          <p className={styles.menuText}>خروج از حساب کاربری</p>
          <div className={styles.iconContainer}>
            <Logout className={styles.menuIcon} />
          </div>
        </div>
      </div>

      <div className={styles.divider}></div>
    </>
  );
};

export default ProfileMenuList;
